if(!customElements.get('swym-directory-page')){
    class SwymDirectoryPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');
            this.listSenderName = this.querySelector('#swymcs-lists-share-sender-details-name-value'); 
            this.listSenderEmail = this.querySelector('#swymcs-lists-share-sender-details-email-value');
            this.listSenderTier = this.querySelector('#swymcs-lists-share-sender-details-tier-value');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');
            this.pageLoader = this.querySelector("#swymcs-loader-container");

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.emailShareButton = this.querySelector('#swymcs-confirm-share-list');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);
            this.shareListButton.addEventListener('click', this._renderShareListPopup.bind(this));

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.emailShareButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));
        }

        async _triggerBackToListView(){
            // await this._renderWishlist(_swat);
            this._renderWishlists();
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-directory-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getCompleteListDetails();
            this.lists.length ? this._renderWishlists() : this._renderEmptyState();
        }

        async _renderShareWishlist(){
            const lid = new URL(document.location).searchParams.get("lid");
            
            // Common UI updates
            const updateUI = (showHeader = true) => {
                this._showContainer(this.listProductsContainer);
                this._showContainer(this.wishlistContainer);
                this._hideContainer(this.pageLoader);
                this._hideContainer(this.backToListView);
                if (!showHeader) {
                    this._hideContainer(this.wishlistHeader);
                }
            };

            if(!lid){
                this._renderProductsGrid([]);
                updateUI(false);
                return;
            }

            window.currentActiveListId = lid;
            try {
                const wishlistProducts = await this._getProductsFromList(lid);
                this.listcontents = await this._getShopifyProductsData(wishlistProducts);                
                if(!this.listcontents || !this.listcontents.length){
                    this._renderEmptyList();
                    updateUI(false);
                    return;
                }
                
                await this._renderSharedListHeader(lid);
                this._renderProductsGrid(this.listcontents);
                if(window.isLoggedIn && window.isStoreOwner ) this._showCopyLinkInput();
                updateUI();
            } catch (error) {
                console.error('Error fetching wishlist products:', error);
                this._renderEmptyList();
                updateUI(false);
            }
        }

        _renderWishlists() {
            if(!this.lists.length){
                this._renderEmptyState();
                return;
            }
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this._hideContainer(this.pageLoader);
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            let html = ``;
            this.lists.forEach(list => {
                if(list == null) return;
                const listContents = list?.listcontents || [];

                let buttonText = !listContents.length ? 'Continue Shopping' : 'View List';
                let buttonAction = !listContents.length ? 'shop' : 'view-list';
                let imageHtml = `<div class="swymcs-list-image-container">`;
                if(listContents.length){
                    for(let i = 0; i < 3; i++){
                        if(listContents[i]){
                            const imageSrc = listContents[i].productData.featured_image || listContents[i].productData.images[0] || listContents[i].iu;
                            imageHtml += `
                                <div class="swymcs-wishlist-image-wrapper">
                                    <img src="${imageSrc}" alt="${listContents[i].productData.title}" class="swymcs-wishlist-image"/>
                                </div>`;
                        }
                    }
                    imageHtml += '</div>';
                }
                else imageHtml += ` <p class="swymcs-no-products-message">This is an empty list!</p></div>`;

                html += `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" data-lid="${list.lid}" aria-label="View list ${list.lname}" id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-subtitle-container">
                            <div class="swymcs-list-subtitle">${list.lprops.customer_details.name}</div>
                            <div class="swymcs-list-badge ${list.lprops.customer_details.tier}">${list.lprops.customer_details.tier}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${listContents.length}</span>
                            <span class="swymcs-product-count-text">${listContents.length > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button button" data-action="${buttonAction}" id="swymcs-view-list-button-${list.lid}" aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            });
            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._hideContainer(this.pageLoader);
            this._scrollToTop();
        }

        async _renderListProducts(lid){
            this._hideContainer(this.listsContainer);
            this._showContainer(this.pageLoader);
            window.currentActiveListId = lid;
            const activeList = this.lists.find(list => list.lid == lid);
            const wishlistProducts = activeList.listcontents; 
            this._hideContainer(this.activeListContainer);
            this._hideContainer(this.pageLoader);
            this._renderProductsGrid(wishlistProducts);
            this._showContainer(this.listProductsContainer);
            this._updateSenderDetailsOnHeader(activeList);
        }

        async _renderSharedListHeader(lid){
            const { list: activeList } = await this._getListDetails(lid);
            activeList.listcontents = this.listcontents;
            this._renderActiveList(activeList);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
            this._hideContainer(this.shareListButton);
            if(window.isLoggedIn && window.isStoreOwner){
                this._updateSenderDetailsOnHeader(activeList);
            }
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                if(list == null) return;
                const listContents = list?.listcontents || [];
                if(listContents.length){
                    const imageSrc = listContents[0].productData.featured_image || listContents[0].productData.images[0] || listContents[0].iu;
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${imageSrc}" alt="${list.lname}"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const listContent = list?.listcontents || [];
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                const imageSrc = listContent[0].productData.featured_image || listContent[0].productData.images[0] || listContent[0].iu;
                this.activeListImage.src = imageSrc;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts){
            if(!shopifyProducts.length) {
                this._renderEmptyList();
                return;
            }
            let productMarkup = ``;
            shopifyProducts.forEach(async (pdp, index) => {
                if(!pdp) return;
                const product = pdp.productData;
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                if(!selectedVariant) return;
                const selectedVariantTitle = selectedVariant.title && selectedVariant.title.toLowerCase() != 'default title' ? selectedVariant.title : '';
                const selectedVariantPrice = parseFloat(selectedVariant.price/100.00).toFixed(2);
                const selectedVariantCompareAtPrice = selectedVariant.compare_at_price > 0 && selectedVariant.compare_at_price != selectedVariant.price ? parseFloat(selectedVariant.compare_at_price/100.00).toFixed(2) : 0;
                const labelText = product.metafieldData != 'NA' ? product.metafieldData : '';
                let addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                let isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                let isButtonDisabled = isSoldOut ? 'disabled': '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const productUrl = pdp?.product?.du || pdp.du;

                productMarkup += `
                   <li id="wishlist-grid-item--${index}"  data-url="${productUrl}" data-lid="${lid}" data-epi="${selectedVariant.id}" class="product-grid__item product-grid__item--${index} swymcs-product-card">
                        <div class="card-wrapper swymcs-list-product product-card-wrapper underline-links-hover" bis_skin_checked="1">
                            <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="swym-hide-container swymcs-button swymcs-product-delete-btn" aria-label="Delete ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <div class="card card--standard card--media" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;" bis_skin_checked="1">
                                    <div class="card__media" bis_skin_checked="1">
                                        <div class="media media--transparent media--hover-effect" bis_skin_checked="1">
                                            <img src="${imageSrc}" alt="${product.title}" class="motion-reduce" loading="lazy"/> 
                                        </div>
                                    </div>
                                </div>
                                <div class="card__content" bis_skin_checked="1">
                                    <div class="card__information" bis_skin_checked="1">
                                        <h3 class="card__heading h5">
                                            <a href="${productUrl}" class="full-unstyled-link" aria-label="Visit ${product.title} page">${product.title}</a>
                                        </h3>
                                        <div class="card-information" bis_skin_checked="1">
                                            <span class="visually-hidden">Vendor:</span>
                                            <div class="caption-with-letter-spacing light" bis_skin_checked="1">${product.vendor}</div>
                                            <div class="price " bis_skin_checked="1">
                                                <div class="price__container" bis_skin_checked="1">
                                                    <div class="price__regular" bis_skin_checked="1">
                                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                        <span class="price-item price-item--regular">
                                                            ${currencyCode}${selectedVariantPrice}
                                                        </span>
                                                    </div>
                                                    ${selectedVariantCompareAtPrice > 0 ? `
                                                        <div class="price__sale" bis_skin_checked="1">
                                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                                        <span>
                                                            <s class="price-item price-item--regular"></s>
                                                        </span>
                                                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                                        <span class="price-item price-item--sale price-item--last">
                                                            ${currencyCode}${selectedVariantCompareAtPrice}
                                                        </span>
                                                        </div>` : ``
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__badge bottom left" bis_skin_checked="1"></div>
                                <div class="swymcs-product-buttons">
                                    <button ${isButtonDisabled} data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" 
                                        class="${inCart} ${isSoldOut} ${this.settings.swym_show_add_to_cart_button ? '' : 'swym-hide-container'} swymcs-major-button button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}">
                                        ${addToCartBtnText}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this.productsContainer.classList.remove('swymcs-empty-list');
            this._scrollToTop();
        }

        _renderEmptyList(){
            this.productsContainer.classList.add('swymcs-empty-list');
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderShareListPopup(evt){
            this._closeAdditionalOptionsPopup();
            this._renderShareList();
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-directory-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            if(!window.isLoggedIn){
                this._hidePopupContainer(this.additionalOptionsContainer);
                this._showPopupContainer(this.accountPopup);
                return;
            }
            // const list = await this._markListAsPublic();
            const list = this.lists.find(list => list.lid == window.currentActiveListId);
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
              }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => resolve(null)
                );
            });
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }

        async _getCompleteListDetails(){
            const lids = window.swymDirectoryPageLidsArray;
            if (!lids.length) return [];

            const lists = await Promise.all(lids.map(async lid => {
                const listDetails = await this._getListDetails(lid);
                if(listDetails == null) return null;
                const { list } = listDetails;
                const listContents = await this._getProductsFromList(lid);
                list.listcontents = await this._getShopifyProductsData(listContents);
                return list;
            }));

            console.log('Lists fetched: ', lists);

            return lists;
        }
      
       async _getShopifyProductsData(products){
            if(!products.length) return []; 
            const section = this;   
            let buggedProductsArray = []; 
            let res = await Promise.all(products.map(async (pdp) => {
                try {
                    const productHandleString = pdp.du.split('/products/')[1];
                    const productHandle = productHandleString.split('?')[0];
                    const reqURL = `/products/${productHandle}`;
                    const productData = await fetch(`${reqURL}.js`);
                    const jsonData = await productData.json();
                    pdp.productData = jsonData;
                    return pdp;
                }
                catch(error){
                    const errorObj = {}; 
                    errorObj[pdp.du] = error; 
                    buggedProductsArray.push(errorObj);
                    return null; 
                }
            }));

            console.log('Products with bugs - ', buggedProductsArray);
            res = res.filter(product => product && product.productData);
            return res;
        }

        _deleteProductFromList(product, lid, parentNode){
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('.swymcs-product-card')){
                    this._renderProductsGrid([]);
                }
                // this.lists = await this._getLists();
                this.lists = this.lists.map(list => list.lid === lid ? { ...list, listcontents: list.listcontents.filter(product => product.epi !== deletedProduct.epi) } : list);
                this._renderListHeader(lid);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                const listcontents = this.lists.find(list => list.lid === updatedListObj.lid).listcontents;
                updatedListObj.listcontents = listcontents;
                // this.lists = await this._getLists();
                this.lists = this.lists.map(list => list.lid === updatedListObj.lid ? updatedListObj : list);
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                this._closeAdditionalOptionsPopup();
                this.swat.ui.open();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                // this._renderWishlist(_swat);
                this.lists = this.lists.filter(list => list.lid != window.currentActiveListId);
                this._renderWishlists();
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        async _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = await this._getLists();
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                button.classList.add('swymcs-product-in-cart');
                button.textContent = 'Added to cart'; 
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            }, (error) => {
                button.textContent = 'Add to cart';
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        async _addAllProductToCart(evt) {
            const page = this;
            try {
                const productsData = [...page.querySelectorAll('.swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)')].map(container => ({
                    id: +container.dataset.epi,
                    quantity: 1
                }));
                let formData = { 'items': productsData };
        
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
        
                const cartResponse = await response.json();
                cartResponse.items.forEach(item => {
                    const variantId = item.id;
                    const button = page.querySelector(`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`);
                    button.textContent = 'Added to cart';
                });
                evt.target.textContent = 'Added to cart';
                this._scrollToTop();
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            } catch (error) {
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
                console.error('Error:', error);
            }
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-directory-page');
            const lid = evt.target.dataset.lid;
            page._hideContainer(page.listProductsContainer);
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        /* Product Grid Events */
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            const page = document.querySelector('swym-directory-page');
            const purpose = target.dataset?.purpose;
            if(!purpose) return; 
            evt.preventDefault();
            if(purpose == 'cart') page._addProductToCart(target);
            else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('.swymcs-product-card')
                );
            }
        }

        /* Additional Options */

        _updateSenderDetailsOnHeader(list){
            const customerDetails = list.lprops?.customer_details;
            this.listSenderName.textContent = customerDetails?.name || 'NA';
            // this.listSenderEmail.textContent = customerDetails?.email; //Email not required
            this.listSenderTier.textContent = customerDetails?.tier || 'NA';
        }

        _showCopyLinkInput() {
            const container = this.querySelector('#swymcs-copy-link-container');
            const input = this.querySelector('#swymcs-copy-link-input');
            const button = this.querySelector('#swymcs-copy-link-button');
            
            input.value = window.currentActiveListId;
            this._showContainer(container);

            // Add new event listener
            button.addEventListener('click', () => {
                navigator.clipboard.writeText(input.value)
                .then(() => {
                    button.classList.add('copied');
                    button.querySelector('.swymcs-copy-text').textContent = 'Copied!';
                    setTimeout(() => {
                        button.classList.remove('copied');
                        button.querySelector('.swymcs-copy-text').textContent = 'Copy';
                    }, 2000);
                });
            });
        }

        _hideCopyLinkInput() {
            const container = this.querySelector('#swymcs-copy-link-container');
            this._hideContainer(container);
        }
    }
    customElements.define('swym-directory-page', SwymDirectoryPage);
}